import React, { createContext, useState } from "react";

//custom - Vasthuparam

import { vasthuUrl } from "../../component/Api";
import OfferListTable from "./OfferListTable";

export const CrmUserListContext = createContext({});

export default function Offers() {
  const token = window.sessionStorage.getItem("token");

  const [userList, setUserList] = useState([]);
  const [message, setMessage] = useState("");

  const fetchInfo = async () => {
    vasthuUrl
      .get("/data/getallusers", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log("RESULT LIST OF USERS", res.data);
        setUserList(res.data);
      })
      .catch((err) => {
        // setMessage(err)
        setMessage("Network error - UserList Not fetched properly");
      });
  };

  React.useEffect(() => {
    fetchInfo();
  }, [setUserList]);

  return (
    <CrmUserListContext.Provider
      value={{ userList, message, setUserList, setMessage, token }}
    >
      <OfferListTable title="User List for Offers" />
    </CrmUserListContext.Provider>
  );
}

